import { Stack, Button, Collapse } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useState } from "react";
import { DesignerMinimumRequirements } from "../../../components/designer-minimum-requirements";

export const DesignerWelcomePopupPageOne = () => {
  const [showMinimum, setShowMinimum] = useState(false);

  return (
    <div className="designer-welcome-popup-page designer-welcome-popup-page--intro">
      <p className="designer-welcome-popup-copy font-size-4">
        Before applying for the Home Design Guild Seal of Approval and
        Membership, take a moment to review the membership qualifications and
        application requirements. Our selective membership process ensures that
        each designer benefits from exclusive territory rights and higher
        potential client match rates.
      </p>
      <p className="designer-welcome-popup-copy font-size-4">
        To maintain the prestige of our seal, every designer in our network
        undergoes a rigorous vetting process. Our goal is to ensure that members
        uphold excellence across four key pillars critical to exceptional client
        relationships:
      </p>
      <ul className="designer-welcome-popup-pillars">
        <li className="designer-welcome-popup-copy font-size-4">
          <b>Communication:</b> Clear and effective interaction with clients
        </li>
        <li className="designer-welcome-popup-copy font-size-4">
          <b>Transparency:</b> Open and honest practices throughout projects
        </li>
        <li className="designer-welcome-popup-copy font-size-4">
          <b>Project Management:</b> Streamlined and professional execution of
          timelines and deliverables
        </li>
        <li className="designer-welcome-popup-copy font-size-4">
          <b>Interior Design:</b> Creative, innovative, and client-focused
          design solutions
        </li>
      </ul>
      <p className="designer-welcome-popup-copy font-size-4">
        By earning the Home Design Guild Seal, you position yourself as a
        top-tier professional synonymous with quality, trust, and unmatched
        expertise in the interior design industry.
      </p>
      <div className="designer-welcome-popup-requirements">
        <Button
          className="designer-welcome-popup-toggle"
          variant="outlined"
          aria-expanded={showMinimum}
          onClick={() => setShowMinimum((value) => !value)}
        >
          <Stack
            direction="row"
            gap={1}
            alignContent="center"
            alignItems="center"
          >
            <span>View Minimum Requirements</span>
            {showMinimum ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </Stack>
        </Button>
        <Collapse in={showMinimum} timeout="auto" unmountOnExit>
          <div className="designer-welcome-popup-requirements-content">
            <DesignerMinimumRequirements />
          </div>
        </Collapse>
      </div>
    </div>
  );
};
